import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
	  List:[],
	  id:'',
	  answerd:false,//已答题的是false变控浅蓝色
	  selectedIndex:[],//点的是哪个题目
	  userInfo:{}
  },
  getters:{//定义过滤方法
    fliterSelctArr(state) {//第一参数是state
      return state.selectedIndex=[]
    }
  },
  mutations: {
	  getlist(state,allList){
			state.List=allList
	  },
	  getid(state,id){
	  			state.id=id
	  },
	  isAnswer(state,answer){
		  state.answerd=answer;
	  },
	  getIndex(state,selectedIndex){
		  state.selectedIndex.push(selectedIndex)
	  },
	  getuserInfo(state,needinfo){
		  state.userInfo=needinfo
	  }
  },
  actions: {
  },
  modules: {
  }
})
